import React from "react";
import ContentModalIndex from "./ContentModalIndex";
import { connect } from "react-redux";

const ContentModal = (props) => {
  const ComponentToRender = ContentModalIndex[props.type];

  return <ComponentToRender />;
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};

export default connect(mapStateToProps)(ContentModal);
